import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const LineGraph = ({ graphData }) => {
  const graphValues = useMemo(() => {
    return Array.isArray(graphData) ? graphData.map((item) => item.total) : [];
  }, [graphData]);

  // Fixed: Use actual labels from data (e.g., item.date, item.label, or item.name)
  const graphLabels = useMemo(() => {
    return Array.isArray(graphData) 
      ? graphData.map((item) => item.date || item.label || item.name ) 
      : [];
  }, [graphData]);

  const data = {
    labels: graphLabels,
    datasets: [
      {
        data: graphValues,
        borderColor: "#42a5f5",
        backgroundColor: "rgba(66, 165, 245, 0.2)",
        tension: 0.4,
        fill: true,
        pointRadius: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "black",
        anchor: "end",
        align: "right",
        font: {
          weight: "light",
        },
      },
    },
    scales: {
      x: {
        display: true,  // Fixed: Show X-axis labels
        ticks: {
          maxRotation: 45,  // Rotate labels if too long
          font: {
            size: 11
          }
        }
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "200px", marginTop: "20px" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineGraph;
